
<div class="dropdown">
  
  <span class="dd-title-test" *ngIf="label != ''" (click)="dropdownClick()" [class.red-text]="shouldBeRed()" [class.align-left]="alignLeft">{{label}}</span>
  <div class="selected-item" (click)="dropdownClick()">{{getSelection()}}
    <img alt="" class="small-triangle" [src]="getDownTriangleSrc()">
  </div>
  <div #dropdownContent class="dropdown-content" [class.right]="right">
    
    <div class="title">{{title}}</div>
    <div *ngIf="shouldBeRed()" class="reset" (click)="reset()">{{getString('resetFilter')}}</div>
    <span class="close-btn" (click)="closeDropdown()">&times;</span>

    <div class="items-box">
      <div class="item" *ngFor="let item of itemListToDisplay" (click)="chooseItem(item)" [class.selected-btn]="isSelected(item)">{{item.value}}</div>
    </div>

  </div>
</div>
